import React from 'react';
import { Checkbox } from '../../ui/checkbox';
import { describeLeadTime, dueDateFor, formatDue } from './templateUtils';

export function TaskChecklist({ tasks, selected, setSelected, startDate }) {
  const allOn = selected.length === tasks.length;
  const toggle = (i) => setSelected(selected.includes(i) ? selected.filter((x) => x !== i) : [...selected, i]);

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm text-gray-600">{selected.length} of {tasks.length} selected</p>
        <button
          type="button"
          onClick={() => setSelected(allOn ? [] : tasks.map((_, i) => i))}
          className="text-sm font-medium text-emerald-700 hover:text-emerald-900"
          data-testid="toggle-all-template-tasks"
        >
          {allOn ? 'Clear all' : 'Select all'}
        </button>
      </div>
      <ul className="divide-y border rounded-lg max-h-[50vh] overflow-y-auto" data-testid="template-task-checklist">
        {tasks.map((task, i) => {
          const due = dueDateFor(startDate, task.days_before);
          return (
            <li key={i}>
              <label className="flex items-start gap-3 p-3 cursor-pointer hover:bg-gray-50 transition-colors" data-testid={`template-task-${i}`}>
                <Checkbox
                  checked={selected.includes(i)}
                  onCheckedChange={() => toggle(i)}
                  className="mt-0.5"
                  data-testid={`template-task-checkbox-${i}`}
                />
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-gray-800">{task.title}</p>
                  {task.description && <p className="text-sm text-gray-500">{task.description}</p>}
                  <div className="flex flex-wrap gap-2 mt-1 text-xs">
                    <span className="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 capitalize">{task.category}</span>
                    <span className="text-gray-500" data-testid={`template-task-due-${i}`}>
                      {due ? `Due ${formatDue(due)} · ${describeLeadTime(task.days_before)}` : 'No due date'}
                    </span>
                  </div>
                </div>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
